import { Box, Grid, IconButton, Typography } from "@mui/material";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import { PayerDto } from "../../../../../../../api-client";

export interface CorrectionBillInfoGridProps {
  payerDto: PayerDto;
  account: string;
  userName: string;
  totalPriceFormatted: string;
  startDate: string;
  handleRemoveAll: (payerIK: string) => void;
}

export function CorrectionBillInfoGrid({
  payerDto,
  account,
  userName,
  totalPriceFormatted,
  startDate,
  handleRemoveAll,
}: CorrectionBillInfoGridProps) {
  return (
    <>
      <Grid
        container
        justifyContent="left"
        alignItems="center"
      >
        <Grid
          item
          xs={1}
        >
          <IconButton
            onClick={() => handleRemoveAll(payerDto.ik)}
            style={{ color: "#ff5722" }}
          >
            <RemoveCircleOutlineIcon />
          </IconButton>
        </Grid>
        <Grid
          item
          xs={11}
        >
          <Typography
            variant="h6"
            textAlign="center"
          >
            {payerDto?.name}
          </Typography>
        </Grid>
      </Grid>
      <Box>
        <Grid
          container
          spacing={1}
          alignItems="center"
          sx={{ mb: 2 }}
        >
          {payerDto.paperReceivingCenter && (
            <Grid
              item
              xs={8}
            >
              <Typography
                variant="subtitle1"
                align="center"
              >
                Papierzentrum
              </Typography>
              <Box className="box">
                <Typography variant="subtitle2">{payerDto.paperReceivingCenter.name}</Typography>
              </Box>
            </Grid>
          )}

          <Grid
            item
            xs={4}
          >
            <Typography
              variant="subtitle1"
              align="center"
            >
              Mandant
            </Typography>
            <Box className="box">
              <Typography variant="subtitle2">{account}</Typography>
            </Box>
          </Grid>

          <Grid
            item
            xs={4}
          >
            <Typography
              variant="subtitle1"
              align="center"
            >
              Startdatum
            </Typography>
            <Box className="box">
              <Typography variant="subtitle2">{startDate}</Typography>
            </Box>
          </Grid>

          <Grid
            item
            xs={4}
          >
            <Typography
              variant="subtitle1"
              align="center"
            >
              Erstellt von
            </Typography>
            <Box className="box">
              <Typography variant="subtitle2">{userName}</Typography>
            </Box>
          </Grid>

          <Grid
            item
            xs={4}
          >
            <Typography
              variant="subtitle1"
              align="center"
            >
              Gesamtpreis
            </Typography>
            <Box className="box">
              <Typography variant="subtitle2">{totalPriceFormatted} €</Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}
